import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// prettier-ignore
const CompanyDeactivationTaskLogEntrySchema = withDefaults({
  'type': 'company-deactivation-task-log-entry',
  'fields': [
    {
      'kind': 'attribute',
      'name': 'companyDeactivationTaskId'
    },
    {
      'kind': 'attribute',
      'name': 'logLevel'
    },
    {
      'kind': 'attribute',
      'name': 'reason'
    },
    {
      'kind': 'attribute',
      'name': 'recordType'
    },
    {
      'kind': 'attribute',
      'name': 'recordId'
    },
    {
      'kind': 'attribute',
      'name': 'message'
    },
    {
      'kind': 'attribute',
      'name': 'data'
    },
    {
      'kind': 'attribute',
      'name': 'createdAt'
    }
  ]
});

export default CompanyDeactivationTaskLogEntrySchema;
